export default {
    component: 'daily_digest',
    name: 'daily_digest',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Component',
        param: 'components',
        type: 'text',
      }
    ]
  }
